const cardNomination = () => {
  const $cards = document.querySelectorAll('.js-card-nomination');

  if ($cards.length) {
    class CardNomination {
      constructor(element) {
        this.$element = element;

        this.$controls = this.$element.querySelector('.js-tabs-controls');
        this.$wrapper = this.$element.querySelector('.js-tabs-wrapper');
        this.$tabs = this.$element.querySelectorAll('.js-tab');
        this.$showButton = this.$element.querySelector('.js-show-button');
        this.$authorText = this.$element.querySelector('.js-card-author');
        this.$image = this.$element.querySelector('.js-card-image img');
        this.$activeTab = this.$element.querySelector('.js-tab.is-active');

        this.updateCardInfo();
        this.setWrapperHeight(this.$activeTab);
        this.setListeners();
      }

      setListeners() {
        this.$controls.addEventListener('change', (evt) => {
          const $target = evt.target;
          const targetIndex = parseInt($target.dataset.index, 10);
          this.changeTab(targetIndex);
          this.updateCardInfo();
        });

        this.$showButton.addEventListener('click', () => {
          this.$element.classList.add('is-open');
          this.setWrapperHeight(this.$activeTab);
        });

        window.addEventListener('resize', () => this.setWrapperHeight(this.$activeTab));
      }

      setWrapperHeight(activeTab) {
        this.$wrapper.style.height = `${activeTab.offsetHeight}px`;
      }

      changeTab(tabIndex) {
        this.$tabs.forEach((tab, index) => {
          if (index !== tabIndex) {
            tab.classList.remove('is-active');
          } else {
            tab.classList.add('is-active');
            this.$activeTab = tab;
            this.setWrapperHeight(this.$activeTab);
          }
        });
      }

      updateCardInfo() {
        const checkedRadio = this.$controls.querySelector('input:checked');
        if (checkedRadio) {
          const {author, imgSrc, imgSrcset} = checkedRadio.dataset;
          if (author) {
            this.$authorText.textContent = ` ${author}`;
          }
          if (imgSrc) {
            this.$image.src = imgSrc;
          }
          if (imgSrcset) {
            this.$image.srcset = imgSrcset;
          }
        }
      }
    }

    $cards.forEach((item) => new CardNomination(item));
  }
};

export {cardNomination};
